export default "__VITE_ASSET__BIgTk_0F__"